module.exports = __webpack_public_path__ + "img/1-4-p2.efdc10f6.svg";